import { createFileRoute } from "@tanstack/react-router";
import { RegnskabPage } from "./-components/RegnskabPage";

export const Route = createFileRoute(
  "/(restricted)/virksomheder/$cvr/regnskab",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <RegnskabPage />;
}
